import React, { useState, } from 'react';
import { isEmpty, } from 'lodash';
import { Button, } from 'reactstrap';
import { multiFactor, } from 'firebase/auth';

import firebase from '../firebase';
import MultiFactorEnrollButton from './MultiFactorEnrollButton';

const auth = firebase.auth();

export default function MultiFactorRequiredNotice(props) {
  const { company, firebaseUser, } = props;
  const [isEnrolled, setEnrolled] = useState(!isEmpty(multiFactor(firebaseUser).enrolledFactors));

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div className="card">
            <div className="card-body text-center">
              <h5 className="mb-3">
                <span className="fas fa-shield-alt mr-1" />
                2段階認証が必要です
              </h5>
              <p>{company.display_name} では2段階認証が必須に設定されています。</p>
              {
                isEnrolled ? (
                  <>
                    <p>2段階認証を使って再ログインしてください。</p>
                    <Button color="primary" onClick={() => auth.signOut()}>ログアウトして再ログインする</Button>
                  </>
                ) : (
                  <>
                    <p>Google Authenticator などの認証アプリで2段階認証を設定してください。</p>
                    <MultiFactorEnrollButton firebaseUser={firebaseUser} label="2段階認証を設定する" onEnrolled={() => setEnrolled(true)} />
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
